import {TheRave} from "../TheRave";
import {Layers, TheRaveLayers} from "./TheRaveLayers";
import {TweenLite, TimelineLite, Power3} from "gsap";
import {TheRaveSound} from "../sound/TheRaveSound";

export class RandomFeatureSign extends PIXI.Container {
    private readonly sign: PIXI.Sprite;

    public get duration(): number {
        return 2;
    }

    constructor() {
        super();
        this.sign = new PIXI.Sprite();
        this.sign.alpha = 0;
        this.sign.anchor.set(0.5, 0.5);
        this.sign.position.set(360, 360);
        this.addChild(this.sign);
    }

    public show(featureName: string): void {
        this.sign.texture = TheRave.assetLoader.getTextures(featureName)[0];
        const textLight:PIXI.spine.Spine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset("textLight"));
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            () => {
                this.sign.position.y = 360;
                TheRaveLayers.getLayer(Layers.NEAR_WIN)?.addChild(this);
                TheRaveSound.playSoundEffect("fsFeatureText", 0);
                textLight.position.x = 360;
                textLight.position.y = 360;
                TheRaveLayers.getLayer(Layers.NEAR_WIN)?.addChild(textLight);
                textLight.state.setAnimation(0, "animation", false);
            },
            TheRave.fullScreenDimLayer.start(),
            TweenLite.to(this.sign, {alpha: 1, duration: 0.4, ease: Power3.easeOut}),
            TweenLite.fromTo(this.sign.scale, {x: 0.8, y: 0.8}, {x: 1.1, y: 1.1, duration: 0.4, ease: Power3.easeInOut})])
            .add([
                TweenLite.to(this.sign.scale, {x: 1, y: 1, duration: 0.4, ease: Power3.easeOut}),
                TweenLite.to(this.sign, {y: 134, duration: 0.4, ease: Power3.easeOut}),
                TweenLite.to(this.sign, {alpha: 1, duration: 1})
            ])
            .add([
                TweenLite.to(this.sign, {alpha: 0, duration: 0.4, ease: Power3.easeOut}),
            ]);
        tl.add(()=>{TheRaveLayers.getLayer(Layers.NEAR_WIN)?.removeChild(textLight);}, 1.0);
        tl.add(TheRave.fullScreenDimLayer.stop(), 0.8);
    }
}